import React, { Fragment, useState } from "react";
import { SolidButton } from "../../global/SolidButton";
import { Hash, Plus, Trash2, Upload, User } from "lucide-react";
import { socialData } from "../../../data/socialData";
import { SmallSolidButton } from "../../global/SmallSolidButton";
import { MyModal } from "../../global/MyModal";

import MyLoader from "../../util/MyLoader";
import { BorderButton } from "../../global/BorderButton";

export default function Socials() {
  const [search, setSearch] = useState("");
  const data = socialData;
  const [deleteId, setDeleteId] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isDisabled, setDisabled] = useState(false);

  const [errors, setErrors] = useState({});
  const [platform, setPlatform] = useState("Select Platform");
  const [icon, setIcon] = useState(null);
  const [des, setDes] = useState(null);
  const [btnText, setBtnText] = useState(null);
  const [socialLink, setSocialLink] = useState(null);
  const platforms = [
    "Telegram",
    "Instagram",
    "Facebook",
    "Whatsapp",
    "LinkedIn",
    "YouTube",

  ];

  // ------------------------------
  // SEARCH FILTER
  // ------------------------------
  const filteredData = data.filter((item) =>
    `${item.title} ${item.subtitle}`
      .toLowerCase()
      .includes(search.toLowerCase()),
  );
  // if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="w-full space-y-4 ">
        <div className="flex items-center justify-end ">
          <SolidButton
            onClick={() => setIsModalOpen(true)}
            children={
              <>
                <Plus className="w-4 h-4" />
                <span>Add Social Handle</span>
              </>
            }
          />
        </div>
        <div
          className="bg-white/80 dark:bg-slate-900/80
               backdrop-blur-xl rounded-2xl  
               border border-state-200/50 dark:border-slate-700/50 
                w-full 
                pb-4
               overflow-x-auto        
              "
        >
          {/* Table */}
          <table className="min-w-full border-collapse ">
            <thead>
              <tr className="bg-slate-100 dark:bg-slate-800/60 border-t border-slate-300 dark:border-slate-700">
                <th className="text-start w-[400px] text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 ps-4">
                  <input
                    type="text"
                    placeholder="Search by title or subtitle"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-[300px] mr-4 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                  />
                </th>
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Links
                </th>
                <th className="text-start space-e-10 px-4 text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Created By
                </th>
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {filteredData.map((item, index) => (
                <tr
                  key={index}
                  className="hover:bg-slate-100 dark:hover:bg-gray-800/20 border-b border-slate-300/40"
                >
                  <td className="text-start  py-2 ps-4">
                    <div className="flex items-center justify-start space-x-2">
                      <img
                        className="w-7 h-7"
                        src={item.icon}
                        alt="social icon"
                      />
                      <div className="flex flex-col justify-start">
                        <h1 className="text-[11px] font-bold text-slate-900 dark:text-slate-200">
                          {item.title}
                        </h1>
                        <p className="text-[11px] font-medium text-slate-500 dark:text-slate-400">
                          {item.subtitle}
                        </p>
                      </div>
                    </div>
                  </td>

                  <td className="text-start py-2 ">
                    <SmallSolidButton
                      onClick={() => {
                        window.open(item.link, "_blank");
                      }}
                    >
                      {item.buttonText}
                    </SmallSolidButton>
                  </td>

                  <td className="text-start   py-2 px-4">
                    <div className="flex flex-col">
                      <span className="text-[12px]  font-medium text-slate-900 dark:text-slate-200">
                        Moon
                      </span>
                      <span className="text-[11px] font-medium text-slate-500 dark:text-slate-400">
                        {item.dateTime}
                      </span>
                    </div>
                  </td>

                  <td className="text-end pe-10">
                    <button
                      onClick={() => setDeleteId(item.id)}
                      className="flex items-center hover:bg-red-400/10 justify-center py-1  border border-gray-400/40 rounded-md px-2 cursor-pointer"
                    >
                      <span className="text-[10px] text-red-400 font-medium mr-1">
                        Delete
                      </span>
                      <Trash2 size={12} className=" text-red-400 " />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* DELETE CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Delete Social Handler?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this handler?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton
            //  onClick={handleDelete}
            children={<span>Delete</span>}
          />
        </div>
      </MyModal>
      {/* ADD / EDIT MODAL */}
      <MyModal
        isOpen={isModalOpen}
        title={isEditMode ? "Update Social" : "Add New Social"}
        onClose={() => setIsModalOpen(false)}
        width="560px"
      >
        <div className="w-full space-y-4 mt-4">
          {/* Platform */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Platform*
            </label>
            <select
              type="text"
              placeholder="E.g. YouTube,Instagram"
              value={platform}
              onChange={(e) => {
                setPlatform(e.target.value);
                if (errors.platform)
                  setErrors((prev) => ({ ...prev, platform: undefined }));
              }}
              aria-invalid={!!errors.platform}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.platform
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            >
              <option value="" disabled>
                Select Platform
              </option>
              {platforms.map((platform) => (
                <option key={platform} value={platform}>
                  {platform}
                </option>
              ))}
            </select>

            {errors.platform && (
              <div className="text-xs text-red-500 mt-1">{errors.platform}</div>
            )}
          </div>
          {/* Icon */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Icon*
            </label>
            <input
              type="text"
              placeholder="E.g. https://upload.Youtube_logo.png"
              value={icon}
              onChange={(e) => {
                setIcon(e.target.value);
                if (errors.icon)
                  setErrors((prev) => ({ ...prev, icon: undefined }));
              }}
              aria-invalid={!!errors.icon}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.icon
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.icon && (
              <div className="text-xs text-red-500 mt-1">{errors.icon}</div>
            )}
          </div>
          {/* Description */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Description*
            </label>
            <textarea
              type="text"
              placeholder="E.g. Join our Page"
              value={des}
              onChange={(e) => {
                setDes(e.target.value);
                if (errors.des)
                  setErrors((prev) => ({ ...prev, des: undefined }));
              }}
              aria-invalid={!!errors.des}
              className={`w-full h-20 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.des
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.des && (
              <div className="text-xs text-red-500 mt-1">{errors.des}</div>
            )}
          </div> 
           {/* Button Text */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Button Text*
            </label>
            <input
              type="text"
              placeholder="E.g. Join Page"
              value={btnText}
              onChange={(e) => {
                setBtnText(e.target.value);
                if (errors.btnText)
                  setErrors((prev) => ({ ...prev, btnText: undefined }));
              }}
              aria-invalid={!!errors.btnText}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.btnText
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.des && (
              <div className="text-xs text-red-500 mt-1">{errors.des}</div>
            )}
          </div>
          {/* Social Link */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Social Link*
            </label>
            <input
              type="text"
              placeholder="E.g. https://youtube.com"
              value={socialLink}
              onChange={(e) => {
                setSocialLink(e.target.value);
                if (errors.socialLink)
                  setErrors((prev) => ({ ...prev, socialLink: undefined }));
              }}
              aria-invalid={!!errors.socialLink}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.socialLink
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.socialLink && (
              <div className="text-xs text-red-500 mt-1">
                {errors.socialLink}
              </div>
            )}
          </div>
          {/* action buttons */}
          <div className="flex space-x-4 justify-end mt-6">
            <BorderButton onClick={() => setIsModalOpen(false)}>
              <span className="text-sm text-slate-400">Cancel</span>
            </BorderButton>
            <SolidButton
              disabled={isDisabled}
              className="px-4 py-2 text-sm space-x-2"
              //   onClick={() => handleSubmit()}
            >
              {isEditMode ? "Update" : "Confirm"}
            </SolidButton>
          </div>
        </div>
      </MyModal>
    </Fragment>
  );
}
